import React, { useContext, useEffect, useState, useRef } from 'react'
import { Context } from '../Context/Context'
import close from '../Components/Images/x-close.png';
import Date from '../Components/Images/date.png';
// import OffToggle from '../Components/Images/OffToggle.png';
// import OnToggle from '../Components/Images/OnToggle.png';
import add from '../Components/Images/add.png';
// import InvoiceModal from './InvoiceModal';

const CreateInvoiceBar = ({ setOpenInvoiceModal, setInvoiceErrorModal }) => {

    const { handleCreateInvoice, createInvoice, handleAddedInvoice, fetchInvoices } = useContext(Context)

    const [payerName, setPayerName] = useState('');
    const [payerEmail, setPayerEmail] = useState('');
    const [dueDate, setDueDate] = useState('');
    const [invoiceNote, setInvoiceNote] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [validationError, setValidationError] = useState({})

    const [errors, setErrors] = useState([]);

    const fieldRefs = {
        payerName: useRef(null),
        payerEmail: useRef(null),
        dueDate: useRef(null),
    };
    const itemFieldRefs = useRef({});


    const [addItem, setAddItem] = useState([
        {
            item_name: '',
            quantity: '',
            unit_price: '',
            net_price: '',
            detail: '',
        },
    ]);


    const handleAddItem = (e) => {
        setAddItem(prev => [
            ...prev,
            {
                item_name: '',
                quantity: '',
                unit_price: '',
                net_price: '',
                detail: '',
                // toggle: false,
            },
        ]);
    };

    // const handleToggle = (index) => {
    //     setAddItem(prev =>
    //         prev.map((item, i) =>
    //             i === index ? { ...item, toggle: !item.toggle } : item
    //         )
    //     );
    // };

    const handleItemChange = (index, field, value) => {
        setAddItem(prev =>
            prev.map((item, i) => {
                if (i !== index) return item;

                let updatedItem = { ...item, [field]: value };

                if (updatedItem) {
                    const qty = Number(updatedItem.quantity);
                    const price = Number(updatedItem.unit_price);
                    updatedItem.net_price = qty && price ? qty * price : 0;
                }

                return updatedItem;
            })
        );
        setErrors(prev => {
            const updatedItemErrors = [...(prev.itemErrors || [])];

            if (updatedItemErrors[index]) {
                updatedItemErrors[index] = {
                    ...updatedItemErrors[index],
                    [field]: ''
                };
            }

            return {
                ...prev,
                itemErrors: updatedItemErrors
            };
        });
    };


    const payload = {
        payer_name: payerName,
        payer_email: payerEmail,
        due_date: dueDate,
        breakdown: addItem.map(item => ({
            item_name: item.item_name,
            quantity: Number(item.quantity),
            unit_price: Number(item.unit_price),
        })),
        total: addItem.net_price,
        notes: invoiceNote,
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const mainErrors = {};
        const itemErrors = [];

        // Validate payer fields
        if (!payerName) {
            mainErrors.payerName = `Please enter your payer's name!`;
        }
        if (!payerEmail) {
            mainErrors.payerEmail = `Please enter your payer's email!`;
        }
        if (!dueDate) {
            mainErrors.dueDate = `Please enter the due date!`;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (payerEmail && !emailRegex.test(payerEmail)) {
            setValidationError({ email: 'Please enter a valid email address.' });
        } else {
            setValidationError({});
        }


        // Validate each item
        addItem.forEach((item, index) => {
            const itemError = {};
            if (!item.item_name) itemError.item_name = 'Please enter your item name!';
            if (!item.quantity) itemError.quantity = 'Please enter the quantity!';
            if (!item.unit_price) itemError.unit_price = 'Please enter the unit price!';
            itemErrors[index] = itemError;
        });

        // If there are any errors in main form or any item
        const hasMainErrors = Object.keys(mainErrors).length > 0;
        const hasItemErrors = itemErrors.some(err => Object.keys(err).length > 0);

        if (hasMainErrors || hasItemErrors) {
            setErrors({ ...mainErrors, itemErrors });
            // Scroll to first main field error
            const firstMainErrorKey = Object.keys(mainErrors)[0];
            if (firstMainErrorKey && fieldRefs[firstMainErrorKey]?.current) {
                fieldRefs[firstMainErrorKey].current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                fieldRefs[firstMainErrorKey].current.focus();
                return;
            }

            // Scroll to first item field error
            for (let i = 0; i < itemErrors.length; i++) {
                const fieldError = itemErrors[i];
                const fieldKey = Object.keys(fieldError)[0];
                if (fieldKey && itemFieldRefs.current[i]?.[fieldKey]) {
                    itemFieldRefs.current[i][fieldKey].current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    itemFieldRefs.current[i][fieldKey].current.focus();
                    break;
                }
            }

            return;
        }


        setErrors({}); // Clear all errors
        setValidationError({})

        setIsSubmitting(true);

        const token = localStorage.getItem('token');

        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/invoices`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${token}`
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (!response.ok) {
                setInvoiceErrorModal(true);
                handleCreateInvoice();
                throw new Error(data.message || 'Failed to create invoice');
            }

            setOpenInvoiceModal(true);
            window.scrollTo(0, 0);
            handleCreateInvoice();
            handleAddedInvoice();
            fetchInvoices()
            return data;
        } catch (error) {
            setInvoiceErrorModal(true);
            console.error('Error creating invoice:', error.message);
        } finally {
            setIsSubmitting(false);
        }
    };


    useEffect(() => {
        let timeout;

        if (!createInvoice) {
            timeout = setTimeout(() => {
                setPayerName('')
                setPayerEmail('')
                setDueDate('')
                setInvoiceNote('')
                setErrors([])
                setAddItem([
                    {
                        item_name: '',
                        quantity: '',
                        unit_price: '',
                        net_price: '',
                        detail: '',
                    },
                ]);
            }, 5200)
        }

        return () => clearTimeout(timeout);
    }, [createInvoice])


    return (
        <div className={`fixed top-0 h-screen bg-white lg:p-10 py-8 px-4 duration-700 text-black z-40 overflow-auto ${createInvoice ? 'sm:w-[510px] w-full right-0' : 'right-[-100%] w-[40%]'}`}>
            <div className='flex justify-between'>
                <div>
                    <h1 className='text-[20px] font-medium'>Create invoice</h1>
                    <p className='text-[14px] text-[#525154] font-normal'>Create and send invoices effortlessly to get paid on time.</p>
                </div>
                <img
                    className='size-5 mt-1 cursor-pointer' src={close} alt=""
                    onClick={handleCreateInvoice}
                />
            </div>
            <form onSubmit={handleSubmit} className='mt-7 text-black/60'>
                <div className='mt-5'>
                    <label className='text-[#525154] text-[14px]'>Payer's name</label>
                    <div className='flex items-center'>
                        <input
                            ref={fieldRefs.payerName}
                            className='border-[1.2px] border-[#D2D0D6] mt-[6px] outline-none py-[10px] px-[14px] w-full rounded-md'
                            type="text"
                            value={payerName}
                            onChange={e => {
                                setPayerName(e.target.value)
                                setErrors(prev => ({
                                    ...prev,
                                    payerName: ''
                                }))
                            }}
                            id="payerName"

                            placeholder='Payer’s name'
                        />
                    </div>
                    {errors.payerName && (
                        <p className="text-red-500 text-sm mt-1">{errors.payerName}</p>
                    )}
                </div>
                <div className='mt-5'>
                    <label className='text-[#525154] text-[14px]'>Payer's mail</label>
                    <div className='flex items-center'>
                        <input
                            ref={fieldRefs.payerEmail}
                            className='border-[1.2px] border-[#D2D0D6] mt-[6px] outline-none py-[10px] px-[14px] w-full rounded-md'
                            id="payerEmail"
                            type="email"
                            value={payerEmail}
                            onChange={e => {
                                setPayerEmail(e.target.value)
                                setErrors(prev => ({
                                    ...prev,
                                    payerEmail: ''
                                }))
                            }}
                            placeholder='Payer’s mail'
                        />
                    </div>
                    {errors.payerEmail && (
                        <p className="text-red-500 text-sm mt-1">{errors.payerEmail}</p>
                    )}
                    {validationError.email && (
                        <p className='text-[#EF4444] font-normal text-[14px] 3xl:text-[23px]'>
                            {validationError.email}
                        </p>
                    )}
                </div>
                <div className='mt-5'>
                    <label className='text-[#525154] text-[14px]'>Due date</label>
                    <div className='flex items-center w-full relative'>
                        <input
                            ref={fieldRefs.dueDate}
                            className='custom-date-input border-[1.2px] border-[#D2D0D6] mt-[6px] outline-none py-[10px] w-full pl-[42px] rounded-md'
                            id="dueDate"
                            type="date"
                            value={dueDate}
                            onChange={e => {
                                setDueDate(e.target.value)
                                setErrors(prev => ({
                                    ...prev,
                                    dueDate: ''
                                }))
                            }}
                            placeholder='Select date'
                            onFocus={(e) => e.target.showPicker && e.target.showPicker()}
                        />
                        <img className='absolute ml-3 mt-1 size-5' src={Date} alt="" />
                    </div>
                    {errors.dueDate && (
                        <p className="text-red-500 text-sm mt-1">{errors.dueDate}</p>
                    )}
                </div>
                {addItem.map((item, index) => {
                    if (!itemFieldRefs.current[index]) {
                        itemFieldRefs.current[index] = {
                            item_name: React.createRef(),
                            quantity: React.createRef(),
                            unit_price: React.createRef(),
                        };
                    }

                    return (

                        <div key={index} className='p-6 rounded-lg border border-[#F3F0F7] flex flex-col gap-6 mt-5'>
                            <div>
                                <label className='text-[#525154] text-[14px]' htmlFor="itemName">Item Name</label>
                                <input
                                    ref={itemFieldRefs.current[index].item_name}
                                    className='border-[1.2px] border-[#D2D0D6] mt-[6px] outline-none py-[10px] px-[14px] w-full rounded-md'
                                    type="text"
                                    value={item.item_name}
                                    onChange={e => handleItemChange(index, 'item_name', e.target.value)}

                                    placeholder='Invoice item name'
                                />
                                {errors.itemErrors?.[index]?.item_name && (
                                    <p className="text-red-500 text-sm mt-1">{errors.itemErrors[index].item_name}</p>
                                )}
                            </div>
                            <div className='flex gap-4'>
                                <div className='w-full'>
                                    <label className='text-[#525154] text-[14px]' htmlFor="itemName">Quantity</label>
                                    <input
                                        ref={itemFieldRefs.current[index].quantity}
                                        className='border-[1.2px] border-[#D2D0D6] mt-[6px] outline-none py-[10px] px-[14px] w-full rounded-md'
                                        type="number"
                                        value={item.quantity}
                                        onChange={e => handleItemChange(index, 'quantity', e.target.value)}
                                        min="0"
                                        onKeyDown={(e) => {
                                            // Prevent e, +, -, ., and other non-numeric keys
                                            const invalidChars = ['e', 'E', '+', '-', '.'];
                                            if (invalidChars.includes(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        placeholder='Quantity'
                                    />
                                    {errors.itemErrors?.[index]?.quantity && (
                                        <p className="text-red-500 text-sm mt-1">{errors.itemErrors[index].quantity}</p>
                                    )}
                                </div>
                                <div className='w-full'>
                                    <label className='text-[#525154] text-[14px]' htmlFor="itemName">Unit Price</label>
                                    <div className='flex items-center relative'>
                                        <input
                                            ref={itemFieldRefs.current[index].unit_price}
                                            className='border-[1.2px] border-[#D2D0D6] mt-[6px] outline-none py-[10px] pl-8 w-full rounded-lg'
                                            type="number"
                                            value={item.unit_price}
                                            onChange={e => handleItemChange(index, 'unit_price', e.target.value)}
                                            min="0"
                                            onKeyDown={(e) => {
                                                // Prevent e, +, -, ., and other non-numeric keys
                                                const invalidChars = ['e', 'E', '+', '-', '.'];
                                                if (invalidChars.includes(e.key)) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            placeholder='Unit Price'
                                        />
                                        <p className='absolute ml-3 mt-[7px] text-[#78757A] text-[16px]'>$</p>
                                    </div>
                                    {errors.itemErrors?.[index]?.unit_price && (
                                        <p className="text-red-500 text-sm mt-1">{errors.itemErrors[index].unit_price}</p>
                                    )}
                                </div>
                            </div>
                            <div>
                                <label className='text-[#525154] text-[14px]' htmlFor="fullName">Amount</label>
                                <div className='flex items-center w-full relative'>
                                    <input
                                        className='border-[1.2px] border-[#D2D0D6] mt-[6px] outline-none py-[10px] pl-8 w-full rounded-lg'
                                        type="number"
                                        value={item.unit_price * item.quantity}
                                        onChange={e => handleItemChange(index, 'net_price', e.target.value)}
                                        disabled
                                        placeholder='Amount'
                                    />
                                    <p className='absolute ml-3 text-[#78757A] mt-[7px] text-[16px]'>$</p>
                                </div>
                            </div>
                            {/* <div className='flex items-center gap-2'>
                            <img
                                onClick={() => handleToggle(index)}
                                src={item.toggle ? OnToggle : OffToggle}
                                alt=""
                                className="cursor-pointer"
                            />
                            <p onClick={() => handleToggle(index)} className='cursor-pointer'>Use quantity and unit price for item</p>
                        </div> */}
                        </div>
                    )
                })}
                <div
                    onClick={handleAddItem}
                    className='text-[#531CB3] cursor-pointer flex items-center gap-2 mt-5 justify-center'
                >
                    <img src={add} alt="" />
                    <p className='font-medium'>Add new item</p>
                </div>
                <div className='mt-10'>
                    <p className='text-[#525154] text-[14px]'>Invoice note</p>
                    <textarea
                        value={invoiceNote}
                        onChange={e => setInvoiceNote(e.target.value)}
                        className='w-full resize-none h-[135px] outline-none mt-[6px] rounded-lg border-[1.2px] border-[#D2D0D6] py-[10px] px-[14px]'
                    ></textarea>
                </div>

                <div className='mt-10'>
                    <p className="text-[#1D1C1F] text-[20px]">SubTotal: ${
                        addItem.reduce((sum, i) => sum + Number(i.unit_price * i.quantity || 0), 0).toFixed(2)
                    }</p>
                </div>
                <div className='flex gap-3 mt-10'>
                    <button
                        className='p-3 rounded-lg w-[25%] border-[1.2px] border-black/10'
                        onClick={handleCreateInvoice}
                    >
                        Cancel
                    </button>
                    <button
                        type='submit'
                        className={`p-[10px] px-4 rounded-lg text-white w-[80%] ${isSubmitting ? 'bg-[#E8E1F5]' : 'bg-[#531CB3]'}`}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            'Loading...'
                        ) : (
                            'Create Invoice'
                        )}
                    </button>
                </div>
            </form>
            {/* <InvoiceModal invoiceErrorModal={invoiceErrorModal} setInvoiceErrorModal={setInvoiceErrorModal} setOpenInvoiceModal={setOpenInvoiceModal} openInvoiceModal={openInvoiceModal} /> */}
        </div>
    )
}

export default CreateInvoiceBar